import {AxiosRequest, HttpUtils} from "../../../utils/HttpUtils";
import {ResourceAppDto} from "../dto/ResourceAppDto";
import {HttpStatus} from "../../common/enums/HttpStatus";
import {ResourceMenuApi} from "./ResourceMenuApi";

export const ResourceAppApi = {

    getResourceAppList: async () => {
        try {
            const requestUrl = '/v1/account/resource/app/list';
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    // getResourceAppDetail: async (id: string) => {
    //     try {
    //         const params = new Map<string, string>();
    //         params.set('id', id);
    //         const requestUrl = HttpUtils.addQueryString('/v1/account/resource/app/detail', params);
    //         const axiosResponse = await AxiosRequest.get(requestUrl);
    //         return axiosResponse.data;
    //     } catch (error: any) {
    //         console.error(error);
    //         return error.response.data;
    //     }
    // },

    getResourceAppMenus: async (appId: string) => {
        try {
            const params = new Map<string, string>();
            params.set('appId', appId);
            const requestUrl = HttpUtils.addQueryString('/v1/account/resource/app/menus', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    getMyResourceMenuTreeList: async (appId: string) => {
        const responseResult = await ResourceAppApi.getMyResourceMenuList(appId);
        if (responseResult.status === HttpStatus.SUCCESS) {
            responseResult.data = ResourceMenuApi.constructResourceMenuTree(responseResult.data);
        }
        return responseResult;
    },

    getMyResourceMenuList: async (appId: string) => {
        try {
            const params = new Map<string, string>();
            params.set('appId', appId);
            const requestUrl = HttpUtils.addQueryString('/v1/account/resource/app/menus/my', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    getResourceAppActions: async (appId: string) => {
        try {
            const params = new Map<string, string>();
            params.set('appId', appId);
            const requestUrl = HttpUtils.addQueryString('/v1/account/resource/app/actions', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    getResourceAppRoles: async (appId: string) => {
        try {
            const params = new Map<string, string>();
            params.set('appId', appId);
            const requestUrl = HttpUtils.addQueryString('/v1/account/resource/app/roles', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    createResourceApp: async (body: ResourceAppDto) => {
        try {
            const requestUrl = '/v1/account/resource/app/create';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    updateResourceApp: async (body: ResourceAppDto) => {
        try {
            const requestUrl = '/v1/account/resource/app/update';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    deleteResourceApp: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/account/resource/app/delete', params);
            const axiosResponse = await AxiosRequest.post(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
};
